import CloseIcon from '@mui/icons-material/Close';
import { observer } from 'mobx-react-lite';
import { LightgalleryItem } from "react-lightgallery";
import styles from './AttachmentImage.module.css';
import commonStyles from './Common.module.css';

function AttachmentImage({ url, onDeleteClick }: IAttachmentImageProps) {

    return (
        <div className={styles.container}>
            <LightgalleryItem key={url} group="images" src={url}>
                <img className={styles.image} src={url} />
                {onDeleteClick && (
                    <CloseIcon fontSize="small" className={[commonStyles.clickableIcon, styles.deleteIcon].join(" ")} onClick={e => {
                        e.stopPropagation();
                        onDeleteClick();
                    }} />
                )}
            </LightgalleryItem>
        </div>
    );
}

export default observer(AttachmentImage);

interface IAttachmentImageProps {
    url: string;
    onDeleteClick?: () => void;
}
